const ACTION_TYPE = "CART";
export const ADD_TO_CART = `${ACTION_TYPE}/ADD_TO_CART`;
export const REMOVE_FROM_CART = `${ACTION_TYPE}/REMOVE_FROM_CART`;
export const ADD_DELIVERY_INFO = `${ACTION_TYPE}/ADD_DELIVERY_INFO`;
export const CHANGE_ORDER_QUANTITY = `${ACTION_TYPE}/CHANGE_ORDER_QUANTITY`;
export const ADD_CURRENCY = `${ACTION_TYPE}/ADD_CURRENCY`;
